import { EVENT_KEY_ESCAPE } from '../../../constants/event'
import { useKeyboardListener } from '../../../hooks'
import { isPdfFile } from '../../../utils/file'
import Button from '../../Button'
import { useFileDownload } from '../../File'
import { FileIcon } from '../../FileIcon'
import { ICON_HEIGHT_24 } from '../../Icon'

import { getIconColor } from './GalleryHeader.utils'

import * as styles from './GalleryHeader.module.css'

import CloseIcon from '../../../icons/close.svg'
import DownloadIcon from '../../../icons/export.svg'
import PrintIcon from '../../../icons/print.svg'

function GalleryHeader({
  className = styles.GalleryHeader,
  downloadFileDocument,
  file,
  scope,
  subject,
  onClose,
}) {
  const { downloadFile } = useFileDownload({
    apiParams: {
      object_id: subject,
      scope,
    },
    downloadFileDocument,
    file,
  })

  useKeyboardListener({
    callback: onClose,
    eventKey: EVENT_KEY_ESCAPE,
  })

  function handleClickDownload() {
    downloadFile()
  }

  return (
    <div className={className}>
      <div className={styles.leftTools}>
        <div className={styles.fileName}>
          <FileIcon
            className={styles.fileIcon}
            file={file}
            getIconColor={getIconColor}
            size={ICON_HEIGHT_24}
          />
          <span className={styles.title}>{file?.filename || file?.name}</span>
        </div>
      </div>
      <div className={styles.rightTools}>
        {isPdfFile(file) && (
          <Button.Icon
            Icon={PrintIcon}
            className={styles.iconTool}
            onClick={handleClickDownload}
          />
        )}
        <Button.Icon
          Icon={DownloadIcon}
          className={styles.iconTool}
          onClick={handleClickDownload}
        />
        <Button.Icon
          Icon={CloseIcon}
          className={styles.iconTool}
          onClick={onClose}
        />
      </div>
    </div>
  )
}

export default GalleryHeader
